import parseUrl from './parse-url';
import initVideos from './videos';
import initChannels from './channels';
import initPlaylists from './playlists';

import defaultSettings from './settings';


export default function Youtube(userSettings) {
  const settings = _.assign({}, defaultSettings, userSettings);

  const adapterMethods = {
    parseUrl,
  };

  adapterMethods.videos = initVideos(settings, adapterMethods);
  adapterMethods.channels = initChannels(settings, adapterMethods);
  adapterMethods.playlists = initPlaylists(settings, adapterMethods);

  _.assign(this, adapterMethods);
}



// WEBPACK FOOTER //
// ./src/transport/adapters/youtube/index.js